<template>
  <div :class="{
    'card-apontamento': true,
    'sugestao': apontamento.sugestao
  }" v-on:click="onClickMethod">
    <div class="time">
      <span v-if="apontamento.sugestao">_ _:_ _</span>
      <span v-else>{{ getDuracao(apontamento.duracao) }}</span>
    </div>
    <div class="info">
      <div class="client">
        <strong>{{ apontamento.cliente ? formatarNome(apontamento.cliente) : 'A definir' }}</strong>
      </div>
      <div class="issue">
        <a :href="getUrlGitlab(apontamento)" :title="`Abrir no GitLab - ${apontamento.title}`" target="_blank">
          {{ apontamento.projeto }}{{ apontamento.issue ? `#${apontamento.issue}` : '' }}
        </a>
      </div>
    </div>
    <div class="description">
      <strong>{{ formatIssueTitle(apontamento.title) }}</strong>
      <span>{{ apontamento.descricao }}</span>
    </div>
    <div class="details">
      <i v-if="apontamento.incidente" class="incidente fa fa-thermometer-full" title="Incidente"></i>
      <i v-else class="fa fa-thermometer-empty" title="Melhoria"></i>
    </div>
    <!-- Botão para duplicar direto para o dia atual da tela -->
    <button
      v-if="!apontamento.sugestao"
      class="btn-duplicate"
      @click.stop="onDuplicateCurrentDay"
      title="Duplicar apontamento para o dia atual"
    >
      <i class="fa fa-copy"></i>
    </button>
    <!-- Botão para abrir o calendário -->
    <span class="duplicate-btn-wrapper" v-if="!apontamento.sugestao">
      <button class="btn-duplicate" @click.stop="showDatePicker = true" title="Duplicar apontamento em outra data">
        <i class="fa fa-calendar-plus-o align-middle"></i>
      </button>
      <div v-if="showDatePicker" class="duplicate-datepicker" @click.stop>
        <div class="duplicate-datepicker-inner">
          <input
            type="date"
            v-model="selectedDate"
            class="form-control duplicate-date-input"
          />
          <button class="btn btn-primary btn-sm" @click="onDuplicateWithDate" :disabled="!selectedDate">Duplicar</button>
          <button class="btn btn-secondary btn-sm" @click="showDatePicker = false">Cancelar</button>
        </div>
      </div>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.card-apontamento {
  display: flex;
  flex-direction: row;
  background-color: white;
  border-radius: 15px;
  border-left: 5px solid #1BB05E;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 4px 0px #b7b7b7;
  cursor: pointer;

  &.sugestao {
    border-color: #F7A01B;
  }

  .time {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    padding-right: 15px;
    margin-right: 15px;
    border-right: 1px solid #ccc;
    width: 100px;
    text-align: center;
  }

  .info {
    width: 25%;
    min-width: 200px;

    .client {
      font-size: 20px;
    }

    .issue {
      font-size: 15px;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    width: calc(calc(100% - calc(131px + 25px)) - 25%);
    padding-right: 15px;
    margin-right: 15px;
    border-right: 1px solid #ccc;
  }

  .details {
    width: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      width: 25px;
      height: 25px;
      font-size: 25px;
      color: #299ac5;
      cursor: pointer;
    }

    .incidente {
      color: #F73F1B;
    }
  }
}

.btn-duplicate {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  margin-right: 16px;
  color: #299ac5;
  font-size: 24px;
  padding: 0;
  outline: none;
  display: flex;
  align-items: center; // <-- garante alinhamento vertical do ícone

  &:hover {
    color: #F7A01B;
  }

  i {
    vertical-align: middle; // <-- garante alinhamento do ícone
    display: inline-block;
    line-height: 1;
  }
}

.duplicate-btn-wrapper {
  position: relative;
  display: inline-block;
  top: 12px; // ajuste para posicionar um pouco mais acima que antes
}

.duplicate-datepicker {
  position: absolute;
  left: 0;
  top: 120%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-width: 260px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.duplicate-datepicker-inner {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.duplicate-date-input {
  height: 36px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #6c757d;
  padding: 4px 8px;
  min-width: 140px;
  margin-right: 8px;
  background: #fff;
  color: #495057;
}

.btn.btn-primary.btn-sm,
.btn.btn-secondary.btn-sm {
  height: 36px;
  padding: 0 12px;
  font-size: 15px;
  border-radius: 4px;
  margin-right: 4px;
}

.btn.btn-secondary.btn-sm {
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #6c757d;
}

.btn.btn-primary.btn-sm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>

<script>
import Uteis from '@/mixins/utils.js';

export default {
  name: 'CardApontamento',

  props: {
    apontamento: {
      type: Object,
      required: true,
    },
    onClick: {
      type: Function,
      required: false,
      default: () => { }
    },
    currentDate: { // Receba a data do dia atual da tela
      type: String,
      required: true
    }
  },

  mixins: [
    Uteis,
  ],

  data() {
    return {
      showDatePicker: false,
      selectedDate: null,
    };
  },
  computed: {
    minDate() {
      // Define a data mínima como hoje
      return new Date().toISOString().slice(0, 10);
    }
  },
  methods: {
    getUrlGitlab(apontamento) {
      const url = `http://gitlab.meta.com.br/${apontamento.path}/`;
      const projeto = apontamento.project_path ? `${apontamento.project_path}/` : '';
      const issue = apontamento.issue ? `issues/${apontamento.issue}` : '';

      return `${url}${projeto}${issue}`;
    },

    formatIssueTitle(title = '') {
      if (!title) {
        return '';
      }
      return title.length < 60 ? title : `${(title || '').slice(0, 60)}...`;
    },

    onClickMethod() {
      this.onClick(this.apontamento);
    },
    onDuplicate() {
      // Mantido para compatibilidade, mas não usado mais
      this.showDatePicker = true;
    },
    onDuplicateCurrentDay() {
      // Emite o evento para duplicar no dia atual da tela
      this.$emit('duplicate-with-date', { apontamento: this.apontamento, date: this.currentDate });
    },
    onDuplicateWithDate() {
      if (this.selectedDate) {
        this.$emit('duplicate-with-date', { apontamento: this.apontamento, date: this.selectedDate });
        this.showDatePicker = false;
        this.selectedDate = null;
      }
    }
  }
}
</script>